import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { SettingsService } from 'src/app/services/services/settings.service';
import { realTimeService } from 'src/app/services/services/realtime.service';
import { queueOverviewItem, realtimeUserGroup } from 'src/app/app-models/realTimeModels';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DialogHelpComponent } from 'src/app/common/dialogs/dialog-help/dialog-help.component';
import { MatDialog } from '@angular/material/dialog';
import { I18NextPipe } from 'angular-i18next';
import { IHelpDialogData } from 'src/app/models';
import { NGXLogger } from 'ngx-logger';
import { HtmlDecoderService } from 'src/app/services/services/html-decoder.service';

@Component({
    selector: 'app-user-groups',
    templateUrl: './user-groups.component.html',
    styleUrls: ['./user-groups.component.scss'],
    standalone: false
})
export class UserGroupsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;

  isLoading = true;
  groups: realtimeUserGroup[] = null;
  totals: realtimeUserGroup = null;
  filter: string = '';
  refreshInterval: number = 10000; // default to 10s
  dataSource = new MatTableDataSource<realtimeUserGroup>([]);
  displayedColumns: string[] = ["userGroupName", "available", "connecting", "connected", "busy", "wrapUp", "noAnswer", "pause", "loggedOff"];
  BreadcrumbsLink = [
    {"label": "Home", "url": "/"},
    {"label": "Real-Time", "url": "/real-time/overview"},
    {"label": "User Groups", "url": "/real-time/user-groups"}];
  private refreshTimer: any;

  constructor(private realTimeService: realTimeService, private htmlDecoderService: HtmlDecoderService, private logger: NGXLogger, private settingsService: SettingsService, private dialog: MatDialog, private i18nextPipe: I18NextPipe) { }

  async ngOnInit(): Promise<void> {
    var settings = await this.settingsService.realtimeSettings();
    this.refreshInterval = Number(settings?.refreshInterval) * 1000 || 10000;
    this.getData();
    this.startRefreshTimer();
  }

  ngAfterViewInit(): void {
    // Connect the sort to the data source after the view is initialized
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterFromProperty() {
    this.dataSource.filter = this.filter.trim().toLowerCase();
  }

  clearFilter() {
    this.filter = '';
    this.dataSource.filter = '';
  }

  getData(): void {
      this.realTimeService.getUserGroups().subscribe({
        next: (response) => {
          this.groups = response.rows?.map((group) => ({
            ...group,
            userGroupName: this.htmlDecoderService.decodeHtmlEntities( group.userGroupName ?? '') ?? ''
          }));
          this.totals = response.totals;
          this.dataSource.data = this.groups;
          // Ensure sort is connected after data loads
          if (this.sort) {
            this.dataSource.sort = this.sort;
          }
          // Reapply filter if one exists
          if (this.filter) {
            this.applyFilterFromProperty();
          }
          this.isLoading = false;
        },
        error: (error) => {
          this.logger.error('Error fetching user groups:', error);
          this.isLoading = false;
        }
      });
  }

  openHelp(): void {
    let data: IHelpDialogData = { title: this.i18nextPipe.transform('realtime:help_title_usergroups'), text: this.i18nextPipe.transform('realtime:help_usergroups') };
        this.dialog.open(DialogHelpComponent, {
      panelClass: 'dialog-help-pannel',
      backdropClass: "backdrop-invisible",
      data,
      width: "600px"
    });
  }

  private startRefreshTimer(): void {
    // Clear any existing timer
    this.stopRefreshTimer();

    // Start new timer
    this.refreshTimer = setInterval(() => {
      this.getData();
    }, this.refreshInterval);
  }

  private stopRefreshTimer(): void {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  encodeURIComponent(value: string): string {
    return encodeURIComponent(value);
  }

  ngOnDestroy(): void {
    this.stopRefreshTimer();
  }

  }

